import React from 'react';
import { UNIT_TYPES } from 'src/utils/constants';
import { cubicMeterToCubicFoot, squareMeterToSquareFoot } from 'src/utils/imperialConverter';

export const useAreaNumUnit = (roomObj: any, measurementSystem: string) => {
  const [area, setArea] = React.useState<{num: string| null, unit: string|null}>({ num: null, unit: null });
  const [airSpace, setAirSpace] = React.useState<{num: string|null, unit: string|null}>({ num: null, unit: null });

  const getAreaNumUnit = React.useCallback(() => {
    const isArea = roomObj.area && !Number.isNaN(+roomObj.area);
    const isAirSpace = roomObj.airspace && !Number.isNaN(+roomObj.airspace);

    if (isArea) {
      if (measurementSystem === "metric") {
        setArea({ num: (+roomObj.area).toFixed(2), unit: UNIT_TYPES.M });
      } else {
        setArea({
          num: squareMeterToSquareFoot(+roomObj.area).toFixed(2),
          unit: UNIT_TYPES.FT,
        });
      }
    }

    if (isAirSpace) {
      if (measurementSystem === "metric") {
        setAirSpace({
          num: (+roomObj.airspace).toFixed(2),
          unit: UNIT_TYPES.M,
        });
      } else {
        setAirSpace({
          num: cubicMeterToCubicFoot(+roomObj.airspace).toFixed(2),
          unit: UNIT_TYPES.FT,
        });
      }
    }
  }, [measurementSystem]);

  React.useEffect(() => {
    getAreaNumUnit();
  }, [getAreaNumUnit]);

  return { area, airSpace };
};
